import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap"
import toastr from "toastr"
import apiURl from "url"

const SubCategoryModal = ({ isOpen, toggle, parentCategories, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    parentId: "",
  })

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSave = async e => {
    e.preventDefault()
    if (!formData.name.trim()) {
      toastr.error("Category Name is required")
      return
    }
    if (!formData.parentId) {
      toastr.error("Parent Category is required")
      return
    }

    try {
      const response = await fetch(`${apiURl}/api/categories/add-subcategory`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          parentId: formData.parentId,
        }),
      })
      const json = await response.json()

      if (response.ok) {
        toastr.success("Sub Category added!")
        setFormData({ name: "", parentId: "" })
        onSave()
        toggle()
      } else {
        toastr.error(json.message || "Failed to add subcategory")
      }
    } catch (err) {
      console.error("Save Error:", err)
      toastr.error("Failed to add subcategory")
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <Form onSubmit={handleSave}>
        <ModalHeader toggle={toggle}>Add Sub Category</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Category Name *</Label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter category name"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Parent Category *</Label>
            <Input
              type="select"
              name="parentId"
              value={formData.parentId}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Parent Category</option>
              {parentCategories.map(cat => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default SubCategoryModal
